import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';
import { postJson } from 'app/common/fetch';
import { selectAppIdOrWb } from 'app/developer-v3/utils/selectors';

export const type = 'appSubscriber';

export const api = buildEntityApi(
  type,
  (path, getState) => {
    const state = getState();
    const { appId, isWb } = selectAppIdOrWb(state);
    const isWbApp = isWb ? '?is_wb_app=t' : '';

    return `/api/platform/v3/integrations/${appId}/subscribers/${path}${isWbApp}`;
  },
  entityApi => {
    entityApi.subscribeUser = (payload, getState) => {
      postJson(entityApi.modelEndpoint(null, getState), payload);
    };
  }
);

export const selectors = buildEntitySelectors(type, () => {});

export const actions = buildEntityActions(type, selectors, api);
